import React from "react";
import "./Footer.scss";
import axelLogoText from "../../Assets/Images/logoText.png";
import twitter from "../../Assets/Icons/twitter.svg";
import opensea from "../../Assets/Icons/opensea.svg";
import discord from "../../Assets/Icons/discord.svg";

function Footer() {
  return (
    <div id="footer">
      <div className="footerContent">
        <img className="logoText" src={axelLogoText} alt="logo" />
        <div className="linkContainer">
          <div className="website">
            <p className="linkSectionHeader">Website</p>
            <ul className="linkList">
              <a href="/#landing">
                <li>Home</li>
              </a>
              <a href="/#vision">
                <li>Vision</li>
              </a>
              <a href="/#roadmap">
                <li>Roadmap</li>
              </a>
              <a href="/#team">
                <li>Team</li>
              </a>
              <a href="/#faq">
                <li>Faq</li>
              </a>
            </ul>
          </div>
          <div className="links">
            <p className="linkSectionHeader">Links</p>
            <ul className="linkList">
              <a href="/">
                <li>Privacy Policy </li>
              </a>
              <a href="/">
                <li>Terms of Service </li>
              </a>
            </ul>
          </div>
          <div className="socialBtns">
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="https://twitter.com/axelcreatures"
            >
              <img className="navItem" src={discord} alt="twitter" />
            </a>
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="https://twitter.com/axelcreatures"
            >
              <img className="navItem" src={twitter} alt="twitter" />
            </a>
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="/"
            >
              <img className="navItem" src={opensea} alt="opensea" />
            </a>
          </div>
              </div>
              <p className="linkSectionHeader">@ 2022 Axel LLC</p>  
      </div>
    </div>
  );
}

export default Footer;
